const getters = {
    keepList: (state) => state.user.keepList,
    dictList: (state) => state.user.dictList,
    depList: (state) => state.user.depList,
    userInfo: (state) => state.user.userInfo,
    menus: (state) => state.user.menus,
    dictMap: (state) => state.user.dictMap,
    pageNav: (state) => state.app.pageNav,
    routeNav: (state) => state.app.routeNav,
    taskId: (state) => state.app.taskId,
    level: (state) => state.task.level,
    orgId: (state) => state.task.orgId,
    mapHeadIndex: (state) => state.task.mapHeadIndex,
    mapHeadId: (state) => state.task.mapHeadId,
    mapId: (state) => state.task.mapId,
    projectDicList: (state) => state.project.projectDic
};
export default getters;
